import React from 'react';
import { useAuth } from 'react-oidc-context';
import { Card, Typography, Alert, Space } from 'antd';
import FileUploaderWidget from '../widget/FileUploaderWidget';
import { getConfig } from '../auth/authConfig';

const { Title, Text, Paragraph } = Typography;

function WidgetTestPage() {
    const auth = useAuth();
    const apiBaseUrl = getConfig('REACT_APP_API_URL', 'https://localhost:8000');

    const handleComplete = (result) => {
        console.log('✅ Widget completed successfully!', result);
        alert(`Файл ${result.outputFile} успешно обработан!`);
    };

    const handleError = (error) => {
        console.error('❌ Widget error:', error);
        alert(`Ошибка: ${error.message}`);
    };

    if (!auth.isAuthenticated) {
        return (
            <div style={{ padding: '50px', textAlign: 'center' }}>
                <Alert
                    message="Требуется авторизация"
                    description="Пожалуйста, войдите в систему для тестирования виджета"
                    type="warning"
                    showIcon
                />
            </div>
        );
    }

    return (
        <div style={{ padding: '20px', background: '#f0f2f5', minHeight: '100vh' }}>
            <div style={{ maxWidth: 1000, margin: '0 auto' }}>
                <Card style={{ marginBottom: 24 }}>
                    <Title level={2}>🧪 Тестирование File Uploader Widget</Title>

                    <Space direction="vertical" style={{ width: '100%' }}>
                        <Alert
                            message="Режим тестирования"
                            description="Это тестовая страница для проверки виджета в изоляции от основного приложения"
                            type="info"
                            showIcon
                        />

                        <Card size="small" style={{ background: '#fafafa' }}>
                            <Paragraph style={{ margin: 0 }}>
                                <Text strong>API URL:</Text> <Text code>{apiBaseUrl}</Text>
                            </Paragraph>
                            <Paragraph style={{ margin: 0 }}>
                                <Text strong>Auth Token (access_token):</Text> <Text code>{auth.user?.access_token ? 'Present ✓' : 'Missing ✗'}</Text>
                            </Paragraph>
                            <Paragraph style={{ margin: 0 }}>
                                <Text strong>User:</Text> <Text>{auth.user?.profile?.name || auth.user?.profile?.sub || 'Unknown'}</Text>
                            </Paragraph>
                        </Card>
                    </Space>
                </Card>

                <FileUploaderWidget
                    apiBaseUrl={apiBaseUrl}
                    authToken={auth.user?.access_token}
                    onComplete={handleComplete}
                    onError={handleError}
                    theme={{
                        token: {
                            colorPrimary: '#52c41a',
                        },
                    }}
                />

                <Card style={{ marginTop: 24, background: '#fffbe6' }}>
                    <Title level={4}>📝 Как это работает:</Title>
                    <ol>
                        <li>Виджет получает <code>apiBaseUrl</code> из конфигурации приложения</li>
                        <li>Токен авторизации берется из OIDC контекста основного приложения</li>
                        <li>Все запросы идут через Nginx на backend (localhost:3000 → backend:8000)</li>
                        <li>При завершении вызывается callback <code>onComplete</code></li>
                        <li>При ошибке вызывается callback <code>onError</code></li>
                    </ol>

                    <Alert
                        message="Проверьте консоль браузера"
                        description="Все события виджета логируются в консоль разработчика (F12)"
                        type="success"
                        showIcon
                        style={{ marginTop: 16 }}
                    />
                </Card>
            </div>
        </div>
    );
}

export default WidgetTestPage;

